export const STICKY_FOOTER_GROUP_TYPE = 'STICKY_FOOTER_GROUP_TYPE';
export const STICKY_FOOTER_CLASS_NAME = 'select-sticky-footer';
